// src/_services/userService.js
import axiosInstance from "../_utils/axiosInstance";
export const fetchCurrentUserInfo = async () => {
    try {
      
        const response = await axiosInstance.get(`/users/myinfo`);
        return response.data;
    } catch (error) {
        const errorMessage =
            error.response?.data?.message || "Failed to fetch user information";
        console.error("Error fetching user info:", errorMessage);
        throw errorMessage;
    }
};

export const fetchToken = async (mail) => {
    try {
        const response = await axiosInstance.get(`/auth/token?email=${mail}`);
        return response.data; // Ensure this is returning only the token if needed
    } catch (error) {
        const errorMessage =
            error.response?.data?.message || "Failed to fetch user token";
        console.error("Error fetching user token:", errorMessage);
        throw errorMessage;
    }
};

export const updateUserInfo = async (updatedFields) => {
    try {
        const response = await axiosInstance.put('/users/modify', updatedFields);
        return response.data;
    }
    catch (error) {
        const errorMessage =
            error.response?.data?.message || "Failed to update the user information";
        console.error("Error updating user information:", errorMessage);
        throw errorMessage;
    }
  };

  export const uploadUserImage = async (avatarFile) => {
    try {
        const formData = new FormData();
        formData.append("avatar", avatarFile); // File, not base64!
        const response = await axiosInstance.post('/users/uploadImage', formData);
        return response.data;
    }
    catch (error) {
        const errorMessage =
            error.response?.data?.message || "Failed to update the user image";
        console.error("Error updating user image:", errorMessage);
        throw errorMessage;
    }
  };
